import { render, staticRenderFns } from "./cms-component-button.vue?vue&type=template&id=23cbb682&scoped=true"
import script from "./cms-component-button.vue?vue&type=script&lang=js"
export * from "./cms-component-button.vue?vue&type=script&lang=js"
import style0 from "./cms-component-button.vue?vue&type=style&index=0&id=23cbb682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cbb682",
  null
  
)

export default component.exports